module.exports = __webpack_public_path__ + "fonts/icomoon.7fad410.ttf";